module.exports = __webpack_public_path__ + "static/index-bordignon-58c87fd67fd554208c74bfa864f79b27.jpg";